import Vue from 'vue'

import { parse } from './query'
import http, { authorize } from './http'
import Contact from './contact'
import { COOKIE_DOMAIN } from './config'
// console.log('COOKIE_DOMAIN: ', COOKIE_DOMAIN)
export default { checkAndRedirect, check: checkAuth, login, logout }

const ids = [
  'contactId',
  'siqPersonaleId',
  'extraPersonaleId',
  'lastName',
  'firstName',
]

const COOKIES = [...ids, 'access_token', 'userId', 'contactEmail']

async function checkAndRedirect() {
  let { redirectTo } = parse(window.location.search)
  if (!redirectTo) {
    redirectTo = '#/landing'
  }

  const auth = checkAuth()
  if (!auth) {
    return
  }

  const contactIdCookie = Vue.cookie.get('contactId')
  // console.log('COOKIE_DOMAIN2: ', COOKIE_DOMAIN)
  if (!contactIdCookie) {
    try {
      await login()
    } catch (error) {
      window.location.href = '#/?message=' + error.message
      return
    }
  }
  // console.log('redirectTo:', redirectTo)
  window.location.href = redirectTo
}

function checkAuth() {
  const accessTokenCookie = Vue.cookie.get('access_token')
  const userIdCookie = Vue.cookie.get('userId')
  return accessTokenCookie && userIdCookie
}

async function login() {
  const accessToken = Vue.cookie.get('access_token')
  authorize(accessToken)

  let contactId = Vue.cookie.get('contactId')
  if (contactId) {
    const contact = await Contact.get(contactId)
    return contact
  }

  const userId = Vue.cookie.get('userId')
  let userUrl = 'UserIdentities'
  userUrl += '?filter[where][userId]=' + userId
  const userResponse = await http.get(userUrl)
  const profile = userResponse.data[0].profile

  Vue.cookie.set('contactEmail', profile.emails[0].value, {
    domain: COOKIE_DOMAIN,
  })

  let contactUrl = 'TzbContacts'
  contactUrl += '?filter[where][_emails.email]=' + profile.emails[0].value
  const { data } = await http.get(contactUrl)
  if (!data.length) {
    throw new Error('Contatto non trovato.')
  }
  contactId = data[0].id
  const contact = await Contact.get(contactId)
  /*
  const [contactPreferences] = await Contact.getPreferences({ contactId })
  contact.contactPreferences = contactPreferences

  const yearId = contact.contactPreferences.defaultYear.id
  const schoolId = contact.contactPreferences.defaultSchool.id

  const [userAuth] = await Contact.getAuths({ contactId, yearId, schoolId })
  contact.userAuth = userAuth */

  if (profile.provider === 'google') {
    contact.gImage = profile.photos[0].value
  }
  ids.forEach(id =>
    Vue.cookie.set(id, contact[id === 'contactId' ? 'id' : id], {
      domain: COOKIE_DOMAIN,
    })
  )
  return contact
}

function logout() {
  COOKIES.forEach(id => Vue.cookie.delete(id, { domain: COOKIE_DOMAIN }))
  return null
}



// WEBPACK FOOTER //
// ./src/service/auth.js